module.exports = __webpack_public_path__ + "img/down-arrow-white.f0e075f0.png";